<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">ACKNOWLEDGEMENTS</p>
<p class="noindent">I’d like to thank many people who were of enormous assistance. The Friends of the Kingston Station, as a group, provided invaluable help. Martha McCabe, who wrote an outstanding history of Kingston Station a decade ago, assembled much of the information on that wonderful old building that made my job easier. Local rail experts Steve Boothroyd, Tim Cranston, Mike Leckie, Don O’Hanley, Edward J. Ozog, Ben Perry, Everett Stuart and Robert Suppicich were invaluable sources of information and ideas. Frank Golet helped me out with early days forest cover. Scott Malloy and Maury Klein offered their experience with previous railroad books. Steve Devine, Marjorie Heppner, Mike Heppner, Gaby Kass-Simon, the Loewenstein family, Jack McCabe and Ray Wolf read draft versions of all or parts of the manuscript and offered many helpful suggestions, although any mistakes are mine alone. Ed Ozog was more than generous in giving permission to use many images from his wonderful historical collection of Rhode Island railroad photographs and ephemera. Jeff Saraceno, editor at The History Press, was an endless source of help and encouragement. Sarina Wyant, Special Collections librarian of the University of Rhode Island, assisted me with document and photo location.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?6ca53193